/**
 * Created by DejanK on 1/24/2017
 *
 * Displays Google Map Marker
 */
import angular from 'angular'

export default {
  bindings: {
    position: '<',
    icon: '<',
    iconSize: '<',
    draggable: '<',
    animation: '<'
  },
  require: {
    MapCtrl: '^rbMap'
  },
  controller: Ctrl
};

Ctrl.$inject = ['RbGoogle'];
function Ctrl(RbGoogle){
  const vm = this;
  let gMapsInit, GoogleMaps, parentMap, marker;

  this.$onInit = ()=>{
    gMapsInit = RbGoogle.getMap()
      .then(getParentMap)
      .then(newMarker);
  };

  this.$onChanges = (changes)=>{
    if(gMapsInit) {
      if(changes.position) gMapsInit.then(onPositionChanged);
      if(changes.icon) gMapsInit.then(onIconChanged);
      if(changes.iconSize) gMapsInit.then(onIconSizeChanged);
      if(changes.draggable) gMapsInit.then(onDraggableChanged);
      if(changes.animation) gMapsInit.then(onAnimationChanged);
    }
  };

  function onPositionChanged(){
    if(marker) marker.setPosition(angular.copy(vm.position))
  }

  function onIconChanged(){
    if(marker) {
      const icon = marker.getIcon();
      marker.setIcon({
        url: vm.icon,
        scaledSize: icon.scaledSize
      });
    }
  }

  function onIconSizeChanged(){
    if(marker) {
      const icon = marker.getIcon();
      marker.setIcon({
        url: icon.url,
        scaledSize: vm.iconSize
      });
    }
  }

  function onDraggableChanged(){
    if(marker) marker.setDraggable(vm.draggable);
  }

  function onAnimationChanged(){
    if(marker) marker.setAnimation(RbGoogle.newAnimation(vm.animation));
  }

  function getParentMap(googleMaps){
    GoogleMaps = googleMaps;
    return vm.MapCtrl.getMap();
  }

  function newMarker(map){
    parentMap = map;
    if(!marker){
      const markerData = {
        map: parentMap,
        position: angular.copy(vm.position) || {lat:0, lng: 0},
        draggable: angular.isDefined(vm.draggable) ? vm.draggable : true
      };

      if(vm.icon){ markerData.icon = { url: vm.icon }; }
      if(vm.iconSize){ markerData.icon.scaledSize = vm.iconSize; }
      if(vm.animation){ markerData.animation = RbGoogle.newAnimation(vm.animation); }
      marker = new GoogleMaps.Marker(markerData);
    }
  }
}
